import React from "react";
import styles from './index.module.css';
import CarTicketsImg from '../../assets/images/brand/CarTicketGroup.png';
import { useSelector } from "react-redux";
import { selectUserDetails } from "../../redux/features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SubFooter = () => {
    const { details } = useSelector(selectUserDetails);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const toggleSignUp = () => navigate('/auth/register');

    return (
        <>
            <div className={`main-container ${styles.footerContainer}`}>
                <div className={`container-content ${styles.footer}`}>
                    <div className={styles.upperFooter}>
                        <div className={styles.upperFooterleft}>
                            <div className={styles.leftFooterTitle}>
                                SUBSCRIBE NOW & <span className={styles.yellowText}>WIN BIG</span> IT'S EASY!
                            </div>
                            {!details.id &&
                                <div className={styles.leftFooterButton}>
                                    <button type="button" className={styles.regBtn} onClick={toggleSignUp}>{t('Register')}</button>
                                </div>
                            }
                        </div>
                        <div className={styles.upperFooterRight}>
                            <img src={CarTicketsImg} alt="Car" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SubFooter;